import {
  SingleProviderConfig,
  ShopType,
  CheckoutType,
  CrossSellType,
} from 'types';
import { allLeadMode, getDefaultCrossSellAction } from 'config';
import { AltafiberTheme } from 'config/themes';
import {
  ATT,
  Brightspeed,
  BrightspeedV2,
  CenturyLink,
  QuantumFiber,
  Frontier,
  Windstream,
  CincinnatiBell,
  Verizon,
  Comcast,
  Cox,
  Spectrum,
  Mediacom,
  Optimum,
  Wave,
  Grande,
  RCN,
  WOW,
  TDS,
  BuckeyeBroadband,
  FidiumFiber,
  //Earthlink,
} from 'config/providers';

export const CincinnatiBellSpecial: SingleProviderConfig = {
  name: 'CincinnatiBellSpecial',
  // TODO: we should change this eventually...
  micrositeCode: 'Cincinnati Bell',
  mainProvider: CincinnatiBell,
  shopType: ShopType.SINGLE_PROVIDER,
  domain: 'cincinnatibellspecial.com',
  defaultCheckoutType: CheckoutType.LEAD_MODE,
  defaultTheme: AltafiberTheme,
  needsDcSession: false,
  source: 'CincinnatiBell',
  homepage: 'https://cincinnatibellspecial.com',
  title: 'Altafiber Internet Authorized Dealer',
  fallbackPhoneNumber: '855-446-1941',
  fallbackLeadModePhoneNumber: '800-972-6964',
  noOffersRetry: 2,
  getCrossSellAction: getDefaultCrossSellAction,
  getCheckoutType: allLeadMode,
  crossSellProviders: [
    ATT,
    Verizon,
    Brightspeed,
    BrightspeedV2,
    CenturyLink,
    QuantumFiber,
    Frontier,
    Windstream,
    //Earthlink,
  ],
  updaterCrossSellActive: true,
  updaterCrossSellProviders: [
    Comcast,
    Cox,
    Spectrum,
    Mediacom,
    Optimum,
    Wave,
    Grande,
    RCN,
    WOW,
    TDS,
    BuckeyeBroadband,
    FidiumFiber,
  ],
};
